import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import AppBar from "@/components/AppBar.vue";
let Login = class Login extends Vue {
    logoutEvent;
    username = "administrator@development";
    password = "";
    mounted() {
        this.logoutEvent();
    }
};
__decorate([
    Action('logout')
], Login.prototype, "logoutEvent", void 0);
Login = __decorate([
    Component({
        components: {
            AppBar
        },
    })
], Login);
export default Login;
